import React from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { ColumnProps } from '../helpers/types';
import NewTaskBtn from './NewTaskBtn';
import Task from './Task';

const Column = ({
  column, tasks, handleAddTask = null, handleUpdateTask,
}: ColumnProps) => (
  <>
    <div className="listItem__container">
      <div className="listItems">
        <h2 className="listItem__title">{column.title}</h2>
        <Droppable droppableId={column.id}>
          {(provided: any) => (
            /* eslint-disable-next-line */
            <div className="drag__container" ref={provided.innerRef} {...provided.droppableProps}>
              {tasks.map((task: any, index: number) => (
                <Task
                  key={task.id}
                  task={task}
                  handleUpdateTask={handleUpdateTask}
                  index={index} />
              ))}
              {provided.placeholder}
              {handleAddTask && <NewTaskBtn handleAddTask={handleAddTask} />}
            </div>
          )}
        </Droppable>
      </div>
    </div>
  </>
);

export default Column;
